<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="data-list-list-view" class="data-list-container">
    <h1>{{ $t("planification_cloturer") }}</h1>
    <br>
      <vs-table ref="table"  :max-items="itemsPerPage" search :data="missions">
  
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
  
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <!-- ADD NEW -->
            <!-- <div v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor'  && user_role !== 'pessNokia' && user_role !== 'rom'"  class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary" @click="addNewData_mission">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">{{ $t("Ajouter") }}</span>
            </div> -->
        
            <div class="flex flex-wrap-reverse items-center data-list-btn-container mb-6" >
            <vs-input label="Entrez la référence " @keyup.enter="Rech_mission()" v-model="search" class="w-2/6 mb-6 "/>
            </div>
            <div class="btn-add-new p-2 mb-6 mr-2 ml-2 rounded-lg cursor-pointer flex items-center text-lg font-medium text-primary border border-solid border-primary" @click="Rech_mission()">
                <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            </div>
            <div class="btn-add-new p-2 mb-6 mr-2 ml-2 rounded-lg cursor-pointer flex items-center  text-lg font-medium text-primary border border-solid border-primary" @click="getAllMissions()">
                <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            </div>
          </div>
  
          <!-- ITEMS PER PAGE -->
          
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ count }}</span>
            </div>
          </vs-dropdown>
        </div>
  
        <template slot="thead">
          <vs-th sort-key="mission_ref">{{ $t("mission_ref") }}</vs-th>
          <vs-th sort-key="mission">{{ $t("mission") }}</vs-th>
          <vs-th sort-key="journey">{{ $t("journey") }}</vs-th>
          <vs-th sort-key="evacuationPlan">{{ $t("evacuationPlan") }}</vs-th>
          <vs-th sort-key="riskZones">{{ $t("riskZones") }}</vs-th>
          <vs-th sort-key="startDate">{{ $t("jobRiskAssessment_step") }}</vs-th>
          <vs-th sort-key="securityEvaluation">{{ $t("securityEvaluation") }}</vs-th>
          <vs-th sort-key="validate_trajet">{{ $t("validate_trajet") }}</vs-th>
          <vs-th sort-key="mission_status">{{ $t("mission_status") }}</vs-th>
          <vs-th sort-key="created_at">{{ $t("created_at") }}</vs-th>
          <vs-th sort-key="updated_at">{{ $t("updated_at") }}</vs-th>
          <vs-th sort-key="action" v-if="user_role !== 'managerSubcontractor'&& user_role !== 'rom' && user_role !== 'nokiaProject'">Action</vs-th>

       </template>
  
        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.poNumber}}</p>
            </vs-td>

            <vs-td>
             <div v-if="tr.missionStep === true" class="flex mb-2">
              <vx-tooltip color="primary" :text="$t('voir_mission')">
              <vs-button @click="missionStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="warning" :text="$t('modifier_mission')">
              <vs-button @click="missionStep_editData(tr)" color="warning" size="default"  type="line" class="ml-2" icon="edit"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="danger" :text="$t('supprimer_mission')">
              <vs-button @click="deleteData_mission(tr.id)" color="danger" size="default"  type="line" class="ml-2" icon="delete"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" :text="$t('confirmer_vehicule')" color="success">
                <vs-button @click="missionStep_confirmation_show(tr)" color="success" type="line" class="ml-2" icon-pack="feather" icon="icon-check-circle"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' " :text="$t('carte')"  color="#595b5c">
                <vs-button @click="carte(tr.id)" color="#595b5c" type="line" class="ml-2" icon-pack="feather" icon="icon-globe"></vs-button>
              </vx-tooltip>

            </div>
              <div v-if="tr.missionStep === false" class="flex mb-2">  
              <vx-tooltip
              v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia'"
              :title="$t('creation_mission')" 
              color="primary"
              :text="$t('etape_1')" >
              <vs-button @click="missionStep(tr)" color="primary" type="filled" icon-pack="feather" icon="icon-home">{{ $t("Ajouter") }}</vs-button>
              </vx-tooltip>
            </div>
            </vs-td>

            <vs-td>
              <div v-if="tr.journeyStep === true" class="flex mb-2">
              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="#00080a" :text="$t('continuer_trajet')" >
              <vs-button  @click="journeyStep_plus(tr)" color="#00080a" type="line"  icon-pack="feather" icon="icon-plus-circle"></vs-button>
              </vx-tooltip>

              <vx-tooltip color="primary" :text="$t('voir_trajet')">
              <vs-button  @click="journeyStep_show(tr)" color="primary" size="default" icon-pack="feather" class="ml-2" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="warning" :text="$t('modifier_trajet')">
              <vs-button  @click="journeyStep_editData(tr)" color="warning" size="default"  type="line" class="ml-2" icon="edit"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="danger" :text="$t('supprimer_trajet')">
              <vs-button @click="deleteData_journeys(tr)" color="danger" size="default"  type="line" class="ml-2" icon="delete"></vs-button>
              </vx-tooltip>

            </div>
              <div  v-if="tr.journeyStep === false && tr.missionStep === true" class="flex mb-2">
              <vx-tooltip
              v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'"
              :title="$t ('creation_trajet')"
              color="primary"
              :text="$t('etape_2')">
              <vs-button  @click="journeyStep(tr)" color="primary" type="filled" icon-pack="feather" icon="icon-home">{{ $t("Ajouter") }}</vs-button>
              </vx-tooltip>
              </div>
            </vs-td>

            <vs-td>          
              <div v-if="tr.evacuationPlanStep === true" class="flex mb-2">
              <vx-tooltip color="primary" :text="$t('voir_evacuation')">
              <vs-button @click="evacuationPlanStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="warning" :text="$t('modifier_evacuation')">
              <vs-button @click="evacuationPlanStep_editData(tr)" color="warning" size="default"  type="line" class="ml-2" icon="edit"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="danger" :text="$t('supprimer_evacuation')">
              <vs-button @click="deleteData_evacuationPlan(tr)"  color="danger" size="default"  type="line" class="ml-2" icon="delete"></vs-button>
              </vx-tooltip>

              </div>
              <div v-if="tr.evacuationPlanStep === false && tr.journeyStep === true" class="flex mb-2">
              <vx-tooltip
              v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'"
              :title="$t('creation_evacuation')"
              color="primary"
              :text=" $t('etape_3')">
              <vs-button @click="evacuationPlanStep(tr)" color="primary" type="filled" icon-pack="feather" icon="icon-home">{{ $t('Ajouter') }}</vs-button>
              </vx-tooltip>              
              </div>
            </vs-td>

            <vs-td>
            
              <div v-if="tr.riskZoneAssessmentStep === true" class="flex mb-2">
              <vx-tooltip  color="primary" :text="$t('voir_zone_exclusion')">
              <vs-button @click="riskZoneAssessmentStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="warning" :text="$t('modifier_zone_exclusion')">
              <vs-button @click="riskZoneAssessmentStep_editData(tr)" color="warning" size="default"  type="line" class="ml-2" icon="edit"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'"  color="danger" :text="$t ('supprimer_zone_exclusion')">
              <vs-button @click="deleteData_riskZoneAssessment(tr)" color="danger" size="default"  type="line" class="ml-2" icon="delete"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role === 'nokiaProject'  || user_role === 'qhsNokia' || user_role === 'pessNokia' || user_role === 'admin' && user_role !== 'rom' && tr.missionRiskZoneAssessment.length"  :color="getOrderMissionColor(tr.id)" :text="$t('alerte')" >
              <vs-button  :color="getOrderMissionColor(tr.id)" size="default" icon-pack="feather" type="line" class="ml-2" icon="icon-alert-triangle"></vs-button>
              </vx-tooltip>
 
            
              </div>
              <div v-if="tr.riskZoneAssessmentStep === false && tr.evacuationPlanStep === true" class="flex mb-2">
              <vx-tooltip
              v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'"
              :title="$t('creation_zone_exclusion')"
              color="primary"
              :text="$t('etape_4')">
              <vs-button @click="riskZoneAssessmentStep(tr)" color="primary" type="filled" icon-pack="feather" icon="icon-home">{{ $t('Ajouter') }}</vs-button>
              </vx-tooltip>              
              </div>
            </vs-td>
            
            <vs-td>
              <div v-if="tr.jobRiskAssessmentStep === true" class="flex mb-2">
              <vx-tooltip color="primary" :text="$t('voir_evaluation_risque')">
              <vs-button  @click="jobRiskAssessmentStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="warning" :text="$t('modifier_evaluation_risque')">
              <vs-button @click="jobRiskAssessmentStep_editData(tr)"  color="warning" size="default"  type="line" class="ml-2" icon="edit"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject'  && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'" color="danger" :text="$t('supprimer_evaluation_risque')">
              <vs-button @click="deleteData_JobRiskAssessment(tr)" color="danger" size="default"  type="line" class="ml-2" icon="delete"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'managerSubcontractor' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'rom' && user_role !== 'pessNokia'" :text="$t('valider_risques')" color="success">
                <vs-button @click="jobRiskAssessmentStep_ValidateData(tr)" color="success" size="default" type="line" class="ml-2" icon-pack="feather" icon="icon-check-circle"></vs-button>
              </vx-tooltip>
            </div>
              <div v-if="tr.riskZoneAssessmentStep === true && tr.jobRiskAssessmentStep === false"  class="flex mb-2">
              <vx-tooltip
              v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor' && user_role !== 'pessNokia' && user_role !== 'rom'"
              :title="$t('creation_evaluation_risque')"
              color="primary"
              :text="$t ('etape_5')">
              <vs-button @click="jobRiskAssessmentStep(tr)" color="primary" type="filled" icon-pack="feather" icon="icon-home">{{ $t("Ajouter") }}</vs-button>
              </vx-tooltip>              
              </div>
            </vs-td>

            <vs-td>
            <div v-if="tr.jobRiskAssessmentStep === true && tr.missionSecurityThreatEvaluations.length" class="flex mb-2">
            <vx-tooltip color="primary" :text="$t('voir_evaluation_securitaire')">
            <vs-button  @click="evalutionSecurityStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
            </vx-tooltip>
            </div>
            </vs-td>

            <vs-td>
            <vs-chip v-if="tr.missionJourney.length && getlang ==='fr'" :color="getOrderStatusColor1(tr.missionJourney[0].enclosed)" class="product-order-status">{{trajetObject[tr.missionJourney[0].enclosed]}}</vs-chip>
            <vs-chip v-if="tr.missionJourney.length && getlang ==='en'" :color="getOrderStatusColor1(tr.missionJourney[0].enclosed)" class="product-order-status">{{trajetObject_en[tr.missionJourney[0].enclosed]}}</vs-chip>

            <vs-chip v-if="!tr.missionJourney.length" :color="getOrderStatusColor1(false)" class="product-order-status">{{$t("rejetée")}}</vs-chip> 
            </vs-td>

            <vs-td v-if="tr.missionJourney.length">
            <vs-chip v-if="tr.missionJourney[0].enclosed && getlang ==='fr'" :color="getOrderStatusColor(tr.enclosed)" class="product-order-status">{{validationObject[tr.enclosed]}}</vs-chip>
            <vs-chip v-if="tr.missionJourney[0].enclosed && getlang ==='en'" :color="getOrderStatusColor(tr.enclosed)" class="product-order-status">{{validationObject_en[tr.enclosed]}}</vs-chip>
            <vs-chip v-if="!tr.missionJourney[0].enclosed" :color="getOrderStatusColor(2)" class="product-order-status">{{$t("non_démarée")}}</vs-chip>
            </vs-td>
            
            <vs-td v-if="!tr.missionJourney.length">
            <vs-chip :color="getOrderStatusColor(2)" class="product-order-status">{{$t("non_démarée")}}</vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{tr.created_at | date_time}}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{tr.updated_at | date_time}}</p>
            </vs-td>

            <vs-td v-if="user_role !== 'managerSubcontractor'&& user_role !== 'rom' && user_role !== 'nokiaProject'" class="whitespace-no-wrap">
              <div class="flex">
                <div v-if="tr.missionJourney.length">
                <vx-tooltip v-if="!tr.missionJourney[0].enclosed" :text="$t('valider_trajet_')" color="success">
                 <feather-icon
                    style="color: darkgreen"
                    icon="CheckCircleIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current"
                    class="mr-2"
                    @click="validerTrajet(tr)"
                  />
                </vx-tooltip>
               <vx-tooltip v-if="tr.missionJourney[0].enclosed && !tr.enclosed" :text="$t('rejet_trajet_')" color="danger">
                  <feather-icon
                    style="color: red"
                    icon="CheckCircleIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                    @click="RejeterTrajet(tr)"
                  />
                </vx-tooltip>
                </div>
                <div v-if="tr.qhsNokiaValidation === true && tr.pessNokiaValidation === true && tr.leadProjectValidation === true && user_role !=='room'">
                <div v-if="tr.missionJourney.length && tr.jobRiskAssessmentStep === true && user_role !=='room'">
                <vx-tooltip v-if=" !tr.enclosed && tr.missionJourney[0].enclosed"  :text="$t('clôturer_mission')" color="success">
                  <feather-icon
                    @click="validerMission(tr.id)"
                    style="color: darkgreen"
                    icon="TargetIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip v-if=" tr.enclosed && tr.missionJourney[0].enclosed"  :text="$t('rejeter_mission')" color="danger">
                  <feather-icon
                    @click="RejeterMission(tr.id)"
                    style="color: red"
                    icon="TargetIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                </div>
                </div>
                <!-- <div v-if="tr.missionJourney.length">
                  <vx-tooltip  :text="$t('Carte')" color="primary">
                  <feather-icon
                    @click="carte(tr.id)"
                    style="color: blue"
                    icon="GlobeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                </div> -->
              </div>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div>
      <div  class="flex flex-wrap justify-between my-5" >
      <vs-button  :disabled="pageCount === 1"  v-if="this.repPrev !== null" @click="prev()" class="ml-4 mb-4">Précédent</vs-button>
      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">Page({{ pageCount }}) / Page({{ countPages }})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAllMissions(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
      <vs-button  :disabled="pageCount === pageTotal"  v-if="this.repNext !== null" @click="next()" class="ml-4 mb-4" >Suivant</vs-button>
      </div>
    </div>
    <div>
     
    </div>
    </div>
  </template>
<script>

const str = 'https://dev.jra.mitigarisk.com/api/'
export default {
  data () {
    return {
      search:'',
      verif_filter:false,
      pageTotal:1,
      pageCount:1,
      count:0,
      validationObject: {
        false: 'En cours',
        true: 'Cloturée'
      },
      validationObject_en: {
        false: 'Verification',
        true: 'Closed'
      },
      trajetObject: {
        false: 'Rejetée',
        true: 'Validée'
      },
      trajetObject_en: {
        false: 'Rejected',
        true: 'Validated'
      },
      activePrompt1 : '',
      user_role : '',
      missions:[],
      objResult:[],
      isMounted: false,
      itemsPerPage: 20
    }
  },
  watch: {
    count (newVal) {
      if (this.isMounted && newVal > 3) {
        this.pageTotal = Math.ceil(newVal / 3)
      } else {
        this.pageTotal = 1
      }
    }
  },
  computed: {
    getlang () {
      return window.getPrendTaCom.$i18n.locale
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.missions.length
    },
    countPages () {
      if (this.isMounted && this.count > 3) {
        return Math.ceil(this.count / 3)
      }
      return 1
    },
    countPagesResulte () {
      if (this.count > 4) {
        return true
      }
      return false
    }
  },
  
  methods: {
    Rech_mission () {
      if (this.search) {
        this.$vs.loading()
        this.$http.get('closed-missions/', { params: {search: this.search, per_page:3} })
          .then((response) => {
            this.objResult = []
            let finale_color = ''
            let stat_yellow = ''
            let stat_red = ''
            const obj_mission_Risk = {
              id_mission : [],
              danger_obj : []
            }
            const obj_mission_Risk_end = {
              id_mission_end : [],
              danger_obj_end : []
            }
          
            this.missions = response.data.results
            const results = response.data.results
            this.pageCount = 1
            this.count = response.data.count
            this.repNext = str + (response.data.next).substr(34)
            this.repPrev = response.data.previous
            results.forEach(event => {
              if (event.missionRiskZoneAssessment.length) {
                obj_mission_Risk.id_mission.push(event.id)
                obj_mission_Risk.danger_obj.push(event.missionRiskZoneAssessment[0].questionHasFileHasSites)
              }
          
            })
            if (obj_mission_Risk.id_mission.length) {
              for (let i = 0; i < obj_mission_Risk.id_mission.length; i++) {
                this.danger_obj_end = []
                const risk_obj = obj_mission_Risk.danger_obj[i]
                risk_obj.forEach(event => {
                  const obj = {
                    mission_id : obj_mission_Risk.id_mission[i],
                    conditionFaux:event.conditionFaux,
                    conditionNa:event.conditionNa,
                    conditionVrai:event.conditionVrai,
                    colorVrai:event.question.colorVrai,
                    //colorNa:event.question.colorNa,
                    colorFaux:event.question.colorFaux,
                    description:event.question.description,
                    site_name:event.site.name
                  //question:event.question,
                  //site:event.site
                  } 
                  this.danger_obj_end.push(obj)
                })  
                obj_mission_Risk_end.id_mission_end.push(obj_mission_Risk.id_mission[i])  
                obj_mission_Risk_end.danger_obj_end.push(this.danger_obj_end)          
              }
            
            }
            if (obj_mission_Risk_end.id_mission_end.length) {
              for (let t = 0; t < obj_mission_Risk_end.id_mission_end.length; t++) {
                const obj_normale = {
                  mission_id :'',
                  valeurColor : ''
                } 
              
                let couleurFaux_red = 0
                let couleurFaux_yellow = 0
                let couleurVrai_red = 0
                let couleurVrai_yellow = 0


                for (let y = 0; y < obj_mission_Risk_end.danger_obj_end.length; y++) {
                  const obj_var = obj_mission_Risk_end.danger_obj_end[y]
                  for (let z = 0; z < obj_var.length; z++) {
                    if (obj_mission_Risk_end.id_mission_end[t] === obj_var[z].mission_id) {

                      if (obj_var[z].conditionFaux === true) {
                      //countFaux++
                        if (obj_var[z].colorFaux === 'yellow') {
                          couleurFaux_yellow++
                        }
                        if (obj_var[z].colorFaux === 'red') {
                          couleurFaux_red++
                        }
                      }

                      if (obj_var[z].conditionVrai === true) {
                      //countVrai++
                        if (obj_var[z].colorVrai === 'yellow') {
                          couleurVrai_yellow++
                        }
                        if (obj_var[z].colorVrai === 'red') {
                          couleurVrai_red++
                        }
                      } 
                    }
                  }
                
                }
                stat_yellow = couleurFaux_yellow + couleurVrai_yellow
                stat_red =  couleurFaux_red + couleurVrai_red

                if (stat_yellow < stat_red) {
                  finale_color = 'red'
                } else if (stat_red < stat_yellow) {
                //yellow
                  finale_color = '#F8B62C'
                } else if (stat_red === stat_yellow) {
                  finale_color = 'red'
                } else if (stat_red === 0 && stat_yellow === 0) {
                  finale_color = 'green'
                } else if (stat_red === 0 && stat_yellow > 1) {
                //yellow
                  finale_color = '#F8B62C'
                } else {
                  finale_color = 'red'
                }      
                obj_normale.mission_id = obj_mission_Risk_end.id_mission_end[t]
                obj_normale.valeurColor = finale_color
                this.objResult.push(obj_normale)
              }
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else if (this.search === '') {
        this.$vs.notify({
          time:4000,
          title: 'ATTENTION',
          text: 'Entrez l\'information.',
          color: 'warning',
          position:'top-center'
        })
        this.$vs.loading.close()
      }
    },
    next () {
      this.$vs.loading()
      this.$http.get(this.repNext)
        .then((response) => {
          this.countNext()
          this.count = 0
          this.objResult = []
          let finale_color = ''
          let stat_yellow = ''
          let stat_red = ''
          const obj_mission_Risk = {
            id_mission : [],
            danger_obj : []
          }
          const obj_mission_Risk_end = {
            id_mission_end : [],
            danger_obj_end : []
          }
          this.missions = response.data.results
          const results = this.missions
          this.missions = response.data.results
          this.count = response.data.count
          this.repNext = response.data.next ? str + response.data.next.substr(34) : null
          this.repPrev = response.data.previous ? str + response.data.previous.substr(34) : null
          results.forEach(event => {
            if (event.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(event.id)
              obj_mission_Risk.danger_obj.push(event.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }
          
          })
          if (obj_mission_Risk.id_mission.length) {
            for (let i = 0; i < obj_mission_Risk.id_mission.length; i++) {
              this.danger_obj_end = []
              const risk_obj = obj_mission_Risk.danger_obj[i]
              risk_obj.forEach(event => {
                const obj = {
                  mission_id : obj_mission_Risk.id_mission[i],
                  conditionFaux:event.conditionFaux,
                  conditionNa:event.conditionNa,
                  conditionVrai:event.conditionVrai,
                  colorVrai:event.question.colorVrai,
                  //colorNa:event.question.colorNa,
                  colorFaux:event.question.colorFaux,
                  description:event.question.description,
                  site_name:event.site.name
                  //question:event.question,
                  //site:event.site
                } 
                this.danger_obj_end.push(obj)
              })  
              obj_mission_Risk_end.id_mission_end.push(obj_mission_Risk.id_mission[i])  
              obj_mission_Risk_end.danger_obj_end.push(this.danger_obj_end)          
            }
            
          }
          if (obj_mission_Risk_end.id_mission_end.length) {
            for (let t = 0; t < obj_mission_Risk_end.id_mission_end.length; t++) {
              const obj_normale = {
                mission_id :'',
                valeurColor : ''
              } 
              
              let couleurFaux_red = 0
              let couleurFaux_yellow = 0
              let couleurVrai_red = 0
              let couleurVrai_yellow = 0


              for (let y = 0; y < obj_mission_Risk_end.danger_obj_end.length; y++) {
                const obj_var = obj_mission_Risk_end.danger_obj_end[y]
                for (let z = 0; z < obj_var.length; z++) {
                  if (obj_mission_Risk_end.id_mission_end[t] === obj_var[z].mission_id) {

                    if (obj_var[z].conditionFaux === true) {
                      //countFaux++
                      if (obj_var[z].colorFaux === 'yellow') {
                        couleurFaux_yellow++
                      }
                      if (obj_var[z].colorFaux === 'red') {
                        couleurFaux_red++
                      }
                    }

                    if (obj_var[z].conditionVrai === true) {
                      //countVrai++
                      if (obj_var[z].colorVrai === 'yellow') {
                        couleurVrai_yellow++
                      }
                      if (obj_var[z].colorVrai === 'red') {
                        couleurVrai_red++
                      }
                    } 
                  }
                }
                
              }
              stat_yellow = couleurFaux_yellow + couleurVrai_yellow
              stat_red =  couleurFaux_red + couleurVrai_red

              if (stat_yellow < stat_red) {
                finale_color = 'red'
              } else if (stat_red < stat_yellow) {
                //yellow
                finale_color = '#F8B62C'
              } else if (stat_red === stat_yellow) {
                finale_color = 'red'
              } else if (stat_red === 0 && stat_yellow === 0) {
                finale_color = 'green'
              } else if (stat_red === 0 && stat_yellow > 1) {
                //yellow
                finale_color = '#F8B62C'
              } else {
                finale_color = 'red'
              }      
              obj_normale.mission_id = obj_mission_Risk_end.id_mission_end[t]
              obj_normale.valeurColor = finale_color
              this.objResult.push(obj_normale)
            }
          }
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    prev () {
      this.$vs.loading()
      this.$http.get(this.repPrev)
        .then((response) => {
          this.countPrev()
          this.count = 0
          this.objResult = []
          let finale_color = ''
          let stat_yellow = ''
          let stat_red = ''
          const obj_mission_Risk = {
            id_mission : [],
            danger_obj : []
          }
          const obj_mission_Risk_end = {
            id_mission_end : [],
            danger_obj_end : []
          }
          this.missions = response.data.results
          const results = this.missions
          this.count = response.data.count
          this.repNext = response.data.next ? str + response.data.next.substr(34) : null
          this.repPrev = response.data.previous ? str + response.data.previous.substr(34) : null
          results.forEach(event => {
            if (event.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(event.id)
              obj_mission_Risk.danger_obj.push(event.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }
          
          })
          if (obj_mission_Risk.id_mission.length) {
            for (let i = 0; i < obj_mission_Risk.id_mission.length; i++) {
              this.danger_obj_end = []
              const risk_obj = obj_mission_Risk.danger_obj[i]
              risk_obj.forEach(event => {
                const obj = {
                  mission_id : obj_mission_Risk.id_mission[i],
                  conditionFaux:event.conditionFaux,
                  conditionNa:event.conditionNa,
                  conditionVrai:event.conditionVrai,
                  colorVrai:event.question.colorVrai,
                  //colorNa:event.question.colorNa,
                  colorFaux:event.question.colorFaux,
                  description:event.question.description,
                  site_name:event.site.name
                  //question:event.question,
                  //site:event.site
                } 
                this.danger_obj_end.push(obj)
              })  
              obj_mission_Risk_end.id_mission_end.push(obj_mission_Risk.id_mission[i])  
              obj_mission_Risk_end.danger_obj_end.push(this.danger_obj_end)          
            }
            
          }
          if (obj_mission_Risk_end.id_mission_end.length) {
            for (let t = 0; t < obj_mission_Risk_end.id_mission_end.length; t++) {
              const obj_normale = {
                mission_id :'',
                valeurColor : ''
              } 
              
              let couleurFaux_red = 0
              let couleurFaux_yellow = 0
              let couleurVrai_red = 0
              let couleurVrai_yellow = 0


              for (let y = 0; y < obj_mission_Risk_end.danger_obj_end.length; y++) {
                const obj_var = obj_mission_Risk_end.danger_obj_end[y]
                for (let z = 0; z < obj_var.length; z++) {
                  if (obj_mission_Risk_end.id_mission_end[t] === obj_var[z].mission_id) {

                    if (obj_var[z].conditionFaux === true) {
                      //countFaux++
                      if (obj_var[z].colorFaux === 'yellow') {
                        couleurFaux_yellow++
                      }
                      if (obj_var[z].colorFaux === 'red') {
                        couleurFaux_red++
                      }
                    }

                    if (obj_var[z].conditionVrai === true) {
                      //countVrai++
                      if (obj_var[z].colorVrai === 'yellow') {
                        couleurVrai_yellow++
                      }
                      if (obj_var[z].colorVrai === 'red') {
                        couleurVrai_red++
                      }
                    } 
                  }
                }
                
              }
              stat_yellow = couleurFaux_yellow + couleurVrai_yellow
              stat_red =  couleurFaux_red + couleurVrai_red

              if (stat_yellow < stat_red) {
                finale_color = 'red'
              } else if (stat_red < stat_yellow) {
                //yellow
                finale_color = '#F8B62C'
              } else if (stat_red === stat_yellow) {
                finale_color = 'red'
              } else if (stat_red === 0 && stat_yellow === 0) {
                finale_color = 'green'
              } else if (stat_red === 0 && stat_yellow > 1) {
                //yellow
                finale_color = '#F8B62C'
              } else {
                finale_color = 'red'
              }      
              obj_normale.mission_id = obj_mission_Risk_end.id_mission_end[t]
              obj_normale.valeurColor = finale_color
              this.objResult.push(obj_normale)
            }
          }
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    countNext () {
      if (this.pageTotal > this.pageCount) {
        if (this.pageCount <= this.count) { this.pageCount = this.pageCount + 1 }
      }
    },
    countPrev () {
      if (this.count > 2) {
        if (this.pageCount > 1) {
          this.pageCount = this.pageCount - 1
        }
      }
    },
    carte (id) {
      this.$http.get(`generate_mission_url/${id}/`)
        .then(response => {
          const url = response.data.url
          window.open(url, '_blank')
        })
        .catch(() => {
          this.$vs.notify({
            time: 4000,
            title: 'ATTENTION',
            text: this.$t('opération_échouée'),
            color: 'warning',
            position: 'top-center'
          })       
        })
    },
    getOrderMissionColor (status) {
      const obj = this.objResult.find(item => item.mission_id === status)
      return obj ? obj.valeurColor : null
    },
    getOrderStatusColor (status) {
      if (status === false) {
        return 'warning'
      } else if (status === true) {
        return 'success'
      } else {
        return 'danger'
      } 
    },
    getOrderStatusColor1 (status) {
      if (status === false) {
        return 'danger'
      } else if (status === true) {
        return 'success'
      }
    },
    planification () {
      this.$router.push('/Planifications').catch(() => {})
    },
    missionStep () {
      this.missionControle = 1
      this.activePrompt1_mission = 1
      this.$router.push('/MissionPlanifications').catch(() => {})
    },
    missionStep_show (tr) {
      this.$http.get(`missions/${tr.id}/`)
        .then(response => {
          this.planification_mission_data = response.data
          this.missionControle = 1
          this.activePrompt1_mission = 2
          this.$router.push('/MissionPlanifications').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
      //this.planification_mission_data = JSON.parse(JSON.stringify(tr))
    },
    missionStep_editData (tr) {
      this.$http.get(`missions/${tr.id}/`)
        .then(response => {
          this.planification_mission_data = response.data
          this.missionControle = 1
          this.activePrompt1_mission = 3
          this.$router.push('/MissionPlanifications').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    missionStep_confirmation_show (tr) {
      this.$http.get(`missions/${tr.id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_mission = 4
          this.planification_mission_data = response.data
          this.$router.push('/MissionPlanifications').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    journeyStep (tr) {
      this.missionControle = 1
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionJourneys').catch(() => {})
    },
    journeyStep_show (tr) {
      this.$http.get(`journeys/${tr.missionJourney[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionJourneys').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    journeyStep_editData (tr) {
      this.$http.get(`journeys/${tr.missionJourney[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionJourneys').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    journeyStep_plus (tr) {
      this.$http.get(`journeys/${tr.missionJourney[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 4
          this.planification_mission_data = response.data
          this.$router.push('/MissionJourneys').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    evacuationPlanStep (tr) {
      this.missionControle = 1
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionEvacuations').catch(() => { })
      
    },
    evacuationPlanStep_show (tr) {
      this.$http.get(`evacuationPlans/${tr.missionEvacuationPlan[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionEvacuations').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    evacuationPlanStep_editData (tr) {
      this.$http.get(`evacuationPlans/${tr.missionEvacuationPlan[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionEvacuations').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    riskZoneAssessmentStep (tr) {
      this.missionControle = 1
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionRiskZones')
    },
    riskZoneAssessmentStep_show (tr) {
      this.$http.get(`riskZoneAssessments/${tr.missionRiskZoneAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionRiskZones').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    riskZoneAssessmentStep_editData (tr) {
      this.$http.get(`riskZoneAssessments/${tr.missionRiskZoneAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionRiskZones').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    jobRiskAssessmentStep (tr) {
      this.missionControle = 1
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionJobRiskAssessments').catch(() => {})
    },
    jobRiskAssessmentStep_show (tr) {
      
      this.$http.get(`jobRiskAssessments/${tr.missionJobRiskAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionJobRiskAssessments').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    jobRiskAssessmentStep_editData (tr) {
     
      this.$http.get(`jobRiskAssessments/${tr.missionJobRiskAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionJobRiskAssessments').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    jobRiskAssessmentStep_ValidateData (tr) {
      
      this.$http.get(`jobRiskAssessments/${tr.missionJobRiskAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_journey = 4
          this.planification_mission_data = response.data
          this.$router.push('/MissionJobRiskAssessments').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    evalutionSecurityStep_show (tr) {
      this.$http.get(`securityThreatEvaluations/${tr.missionSecurityThreatEvaluations[0].id}/`)
        .then(response => {
          this.missionControle = 1
          this.activePrompt1_EvalutionSecurity = 5
          this.planification_mission_data = response.data
          this.$router.push('/MissionEvalutionSecurity').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    addNewData_mission () {
      this.missionStep()
    },
    validerMission (mission) {
      this.$vs.dialog({
        type:'confirm',
        color: 'success',
        title: 'Confirmation mission',
        text: this.$t('confirmer_clôture'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.post('enclose/', {mission})
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('mission_clôturée'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('échoué') })
            })
        }
      })
  
    },
    RejeterMission (mission) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: this.$t('confirmer_clôture'),
        text: this.$t('confirmer_rejet'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.post('enclose/', {mission})
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('mission_rejete'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('échoué') })
            })
        }
      })
  
    },
    validerTrajet (tr) {
      const journey = tr.missionJourney[0].id
      this.$vs.dialog({
        type:'confirm',
        color: 'success',
        title: this.$t('confirmation_trajet'),
        text: this.$t('confirmer_validation'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.post('enclose/', {journey})
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('trajet_validé'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message:this.$t('échoué') })
            })
        }
      })
  
    },
    RejeterTrajet (tr) {
      const journey = tr.missionJourney[0].id
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: this.$t('rejet_trajet'),
        text: this.$t('confirmer_rejet'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.post('enclose/', {journey})
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('trajet_rejeté'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('échoué')})
            })
        }
      })
  
    },
    deleteData_mission (id) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('suppression_mission'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`missions/${id}/`)
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('suppression_valid_mission'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message:this.$t('suppression_error_mission')})
            })
        }
      })
  
    },
    deleteData_evacuationPlan (id) {
      const id_ = id.missionEvacuationPlan[0].id
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('suppression_evacuation'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`evacuationPlans/${id_}/`)
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('suppression_valid_evacuation'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('suppression_error_evacuation')})
            })
        }
      })
  
    },
    deleteData_journeys (id) {
      const id_ = id.missionJourney[0].id
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('suppression_trajet'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`journeys/${id_}/`)
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('suppression_valid_trajet'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('suppression_error_trajet')})
            })
        }
      })
  
    },
    deleteData_riskZoneAssessment (id) {
      const id_ = id.missionRiskZoneAssessment[0].id
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('suppression_zone_exclusion'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`riskZoneAssessments/${id_}/`)
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('suppression_valid_zone_exclusion'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('suppression_error_zone_exclusion')})
            })
        }
      })
  
    },
    deleteData_JobRiskAssessment (id) {
      const id_ = id.missionJobRiskAssessment[0].id
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('suppression_evaluation_risque'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`jobRiskAssessments/${id_}/`)
            .then(response => {
              this.getAllMissions()
              window.getPrendTaCom.success(this.$t('suppression_valid_evaluation_risque'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('suppression_error_evaluation_risque')})
            })
        }
      })
  
    },
    getAllMissions () {
      this.search = ''
      this.$vs.loading()
      this.$http.get('closed-missions/?page=1&per_page=3')
        .then((response) => {
          this.objResult = []
          const obj_mission_Risk = { id_mission: [], danger_obj: [] }
          const obj_mission_Risk_end = { id_mission_end: [], danger_obj_end: [] }

          this.missions = response.data.results
          this.pageCount = 1
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = response.data.previous

          // Collect risk data
          this.missions.forEach(mission => {
            if (mission.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(mission.id)
              obj_mission_Risk.danger_obj.push(mission.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }
          })

          // Structure risk objects
          obj_mission_Risk.id_mission.forEach((id, i) => {
            const risk_objs = obj_mission_Risk.danger_obj[i].map(event => ({
              mission_id: id,
              conditionFaux: event.conditionFaux,
              conditionNa: event.conditionNa,
              conditionVrai: event.conditionVrai,
              colorVrai: event.question.colorVrai,
              colorFaux: event.question.colorFaux,
              description: event.question.description,
              site_name: event.site.name
            }))
            obj_mission_Risk_end.id_mission_end.push(id)
            obj_mission_Risk_end.danger_obj_end.push(risk_objs)
          })

          // Calculate color for each mission
          obj_mission_Risk_end.id_mission_end.forEach((mission_id) => {
            let couleurFaux_red = 0, couleurFaux_yellow = 0, couleurVrai_red = 0, couleurVrai_yellow = 0
            obj_mission_Risk_end.danger_obj_end.forEach(obj_var => {
              obj_var.forEach(obj => {
                if (mission_id === obj.mission_id) {
                  if (obj.conditionFaux) {
                    if (obj.colorFaux === 'yellow') couleurFaux_yellow++
                    if (obj.colorFaux === 'red') couleurFaux_red++
                  }
                  if (obj.conditionVrai) {
                    if (obj.colorVrai === 'yellow') couleurVrai_yellow++
                    if (obj.colorVrai === 'red') couleurVrai_red++
                  }
                }
              })
            })
            const stat_yellow = couleurFaux_yellow + couleurVrai_yellow
            const stat_red = couleurFaux_red + couleurVrai_red
            let finale_color = 'red'
            if (stat_yellow < stat_red) {
              finale_color = 'red'
            } else if (stat_red < stat_yellow) {
              finale_color = '#F8B62C'
            } else if (stat_red === stat_yellow) {
              finale_color = 'red'
            } else if (stat_red === 0 && stat_yellow === 0) {
              finale_color = 'green'
            } else if (stat_red === 0 && stat_yellow > 1) {
              finale_color = '#F8B62C'
            }
            this.objResult.push({ mission_id, valeurColor: finale_color })
          })

          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    paginationAllMissions (npage) {
      this.$vs.loading()
      this.search = ''
      this.$http.get(`${str}closed-missions/`, { params: {page: npage, per_page:3} })
        .then((response) => {
          this.objResult = []
          const obj_mission_Risk = { id_mission: [], danger_obj: [] }
          const obj_mission_Risk_end = { id_mission_end: [], danger_obj_end: [] }

          this.missions = response.data.results
          this.pageCount = 1
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = response.data.previous

          // Collect risk data
          this.missions.forEach(mission => {
            if (mission.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(mission.id)
              obj_mission_Risk.danger_obj.push(mission.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }
          })

          // Structure risk objects
          obj_mission_Risk.id_mission.forEach((id, i) => {
            const risk_objs = obj_mission_Risk.danger_obj[i].map(event => ({
              mission_id: id,
              conditionFaux: event.conditionFaux,
              conditionNa: event.conditionNa,
              conditionVrai: event.conditionVrai,
              colorVrai: event.question.colorVrai,
              colorFaux: event.question.colorFaux,
              description: event.question.description,
              site_name: event.site.name
            }))
            obj_mission_Risk_end.id_mission_end.push(id)
            obj_mission_Risk_end.danger_obj_end.push(risk_objs)
          })

          // Calculate color for each mission
          obj_mission_Risk_end.id_mission_end.forEach((mission_id) => {
            let couleurFaux_red = 0, couleurFaux_yellow = 0, couleurVrai_red = 0, couleurVrai_yellow = 0
            obj_mission_Risk_end.danger_obj_end.forEach(obj_var => {
              obj_var.forEach(obj => {
                if (mission_id === obj.mission_id) {
                  if (obj.conditionFaux) {
                    if (obj.colorFaux === 'yellow') couleurFaux_yellow++
                    if (obj.colorFaux === 'red') couleurFaux_red++
                  }
                  if (obj.conditionVrai) {
                    if (obj.colorVrai === 'yellow') couleurVrai_yellow++
                    if (obj.colorVrai === 'red') couleurVrai_red++
                  }
                }
              })
            })
            const stat_yellow = couleurFaux_yellow + couleurVrai_yellow
            const stat_red = couleurFaux_red + couleurVrai_red
            let finale_color = 'red'
            if (stat_yellow < stat_red) {
              finale_color = 'red'
            } else if (stat_red < stat_yellow) {
              finale_color = '#F8B62C'
            } else if (stat_red === stat_yellow) {
              finale_color = 'red'
            } else if (stat_red === 0 && stat_yellow === 0) {
              finale_color = 'green'
            } else if (stat_red === 0 && stat_yellow > 1) {
              finale_color = '#F8B62C'
            }
            this.objResult.push({ mission_id, valeurColor: finale_color })
          })

          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  },
  
  created () {
    this.user_role = JSON.parse(localStorage.getItem('userInfo')).role
    window.Planifications = this
    this.planification_mission_data = {}
    this.getAllMissions()
    //this.getpaginateMissions()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>
  
  <style lang="scss">
  #data-list-list-view {
    .vs-con-table {
  
      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;
  
          .vs-table--search-input {
            width: 100%;
          }
        }
      }
  
      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }
  
      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;
  
          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }
  
      .product-name {
        max-width: 23rem;
      }
  
      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }
  
        .vs-table--search{
          padding-top: 0;
  
          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;
  
            &+i {
              left: 1rem;
            }
  
            &:focus+i {
              left: 1rem;
            }
          }
        }
      }
  
      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
  
        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }
  
      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;
  
          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }
  
      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
  </style>
  
